
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/assembly-chunav/tamil-nadu/candidates/[candidate]",
      function () {
        return require("private-next-pages/elections/assembly-chunav/tamil-nadu/candidates/[candidate].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/assembly-chunav/tamil-nadu/candidates/[candidate]"])
      });
    }
  